"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceLogAmountCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../utils/roundMoney");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'balance-log-amount-cell';
const BalanceLogAmountCell = (props) => {
    const { amount, direction } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        direction,
    ]);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("span", { className: `${className}__icon` },
            react_1.default.createElement(Icon_1.Icon, { name: 'sort-up' })),
        react_1.default.createElement("span", { className: `${className}__text` }, `${(0, roundMoney_1.localizeMoney)(amount, locale, 'Accounting/BalanceLog/BalanceLogAmountCell')} CHF`)));
};
exports.BalanceLogAmountCell = BalanceLogAmountCell;
//# sourceMappingURL=index.js.map